import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { Box } from '@medely/web-components';
import React from 'react';
import TopBarClean from './TopBarClean';
import TopBarDefault from './TopBarDefault';
import { useTheme } from '@medely/web-components/themes';

const useTopBarMode = (): 'default' | 'clean' | 'none' => {
  const isJobsScheduler = useRouteMatch('/jobs/new');
  const isJobEdit = useRouteMatch('/jobs/:id/edit');
  const isAssignmentJob = useRouteMatch('/scheduler/assignments/jobs/new');
  const isAssignmentsScheduler = useRouteMatch('/scheduler/assignments/new');
  const isTemplates = useRouteMatch('/templates/manager');
  const isNewTemplate = useRouteMatch('/templates/new');
  const isEditTemplate = useRouteMatch('/templates/:id/edit');
  const isThankYou = useRouteMatch('/thank-you');
  if (
    isJobsScheduler ||
    isJobEdit ||
    isAssignmentsScheduler ||
    isAssignmentJob ||
    isNewTemplate ||
    isEditTemplate
  ) {
    return 'clean';
  }
  if (isTemplates || isThankYou) {
    return 'none';
  }
  return 'default';
};

const TopBarContainer = (): React.ReactElement | null => {
  const mode = useTopBarMode();
  const theme = useTheme();
  if (mode === 'none') {
    return null;
  }
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: theme.palette.common.white,
        borderBottom: mode === 'default' ? `solid 1px ${theme.palette.grey[100]}` : undefined,
        boxShadow: mode === 'default' ? 'none' : '0 4px 4px 0 rgba(0, 0, 0, 0.15)',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 4,
        padding: '0 8px',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        '& > *:not(:last-child)': {
          marginRight: '24px',
        },
      }}
    >
      <Switch>
        <Route path="/pro-pool/:locationId/invite">
          <TopBarClean title="Workforce Invite" path="/" />
        </Route>
        <Route path="/pro-pool/invite-accepted">
          <TopBarClean title="Workforce Invite" path="/" />
        </Route>
        <Route>
          <TopBarDefault />
        </Route>
      </Switch>
    </Box>
  );
};

export default TopBarContainer;
